/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Aria_Legal_InfoInputs */

const en_footer_aria_legal_info = /** @type {(inputs: Footer_Aria_Legal_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal information`)
};

const es_footer_aria_legal_info = /** @type {(inputs: Footer_Aria_Legal_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información legal`)
};

/**
* | output |
* | --- |
* | "Legal information" |
*
* @param {Footer_Aria_Legal_InfoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_aria_legal_info = /** @type {((inputs?: Footer_Aria_Legal_InfoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Aria_Legal_InfoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_aria_legal_info(inputs)
	return en_footer_aria_legal_info(inputs)
});